<template lang="pug">
div(class="bg-gray-lighter")
    template(v-if="links.length > 0")
        p(
            @click="isOpen = !isOpen"
            class="flex justify-center items-center text-lg font-bold py-5 cursor-pointer"
        )
            | Related Links&nbsp;

            ArrowIcon(
                class="transform fill-current w-4 h-4 ml-2"
                :class="{ 'rotate-180': isOpen }"
            )

        transition(
            enter-active-class="transition-opacity ease-out duration-200"
            enter-class="opacity-0"
            leave-active-class="transition-opacity ease-in duration-200"
            leave-to-class="opacity-0"
        )
            ul(
                v-show="isOpen"
                class="space-y-2 text-center pb-5"
            )
                template(v-for="link in links")
                    li
                        a(:href="link.url") {{ link.anchor_text }}


</template>

<script>
import ArrowIcon from '@/assets/arrow?inline'
import { intersectionObserverMixin } from '@/helpers/intersectionObserverMixin'

export default {
    name: 'Brightedge',
    components: {
        ArrowIcon,
    },
    mixins: [intersectionObserverMixin],
    data() {
        return {
            isOpen: false,
            links: [],
        }
    },
    watch: {
        $route(newRoute, oldRoute) {
            // if we are on the same route, then we don't want to clear the data
            if (newRoute.path === oldRoute.path) return

            this.links = []
        },
    },
    mounted() {
        this.observe(this.$el, this.fetchLinks)
    },
    methods: {
        async fetchLinks() {
            try {
                // Don't try to refetch the links if we have already fetched them on this page.
                const data = await this.$axios.$get(
                    `https://ixfd-api.bc0a.com/api/ixf/1.0.0/get_capsule/${
                        this.$config.runtime.integrations.brightedge.accountId
                    }/${this.getPageHash()}`
                )

                const supportedTypes = ['link-block', 'link-block-publisher']

                data.nodes.forEach((node) => {
                    if (!supportedTypes.includes(node.publishing_engine)) return
                    const formattedContent = JSON.parse(node.content)
                    this.links = formattedContent.links
                })
            } catch (error) {
                console.log('be no related links')
            }
        },
        // This hash function comes from the brightedge docs
        getPageHash() {
            const pageUrl = window.location.origin + window.location.pathname

            let hash = 0
            if (pageUrl === null || pageUrl.length === 0) {
                return hash
            }

            for (let i = 0; i < pageUrl.length; i++) {
                const charCode = pageUrl.charCodeAt(i)
                hash = (hash << 5) - hash + charCode
                hash = hash & hash // Convert to 32bit integer
            }

            // if hash is a negative number, remove '-' and append '0' in front
            if (hash < 0) {
                hash = '0' + -hash
            } else {
                hash = '' + hash
            }

            return hash
        },
    },
}
</script>
